module.exports = __webpack_public_path__ + "static/3-da647f46cf1d0869e63bb01e2d443675.png";